import { configureStore } from "@reduxjs/toolkit";
import { thunk } from "redux-thunk";
import userLoginSlice from "../slice/userLoginSlice";
import presidentRegistretionSlice from "../slice/presidentRegistretionSlice";
import allSocietySlice from "../slice/allSocietySlice";
import sociteyWingListSlice from "../slice/sociteyWingListSlice";
import addSocietySlice from "../slice/addSocietySlice";
import societyWingListSlice from "../slice/societyWingListSlice";
import societyFlatListSlice from "../slice/societyFlatListSlice";
import addPresidentSlice from "../slice/addPresidentSlice";
import societyListSlice from "../slice/societyListSlice";
import societyDetailsSlice from "../slice/societyDetailsSlice";
import societyUpdateSlice from "../slice/societyUpdateSlice";
import societyStatusSlice from "../slice/societyStatusSlice";
import userAuthenticationSlice from "../slice/userAuthenticationSlice";
import dashboardSocietyCountSlice from "../slice/dashboardSocietyCountSlice";
import societyComplaintSlice from "../slice/societyComplaintSlice";
import helpDeskComplaintSlice from "../slice/helpDeskComplaintSlice";
import dashboardActivitiesSlice from "../slice/dashboardActivitiesSlice";
import userResetPinSlice from "../slice/userResetPinSlice";
import presidentDetailsSlice from "../slice/presidentDetailsSlice";
import presidentUpdateSlice from "../slice/presidentUpdateSlice";
import manageUsersSlice from "../slice/manageUsersSlice";
import amenityListSlice from "../slice/amenityListSlice";
import addAmenitiesSlice from "../slice/addAmenitiesSlice";
import societyAmenitiesSlice from "../slice/societyAmenitiesSlice";
import societyStatusGraphSlice from "../slice/societyStatusGraphSlice";
import societyUsersGraphSlice from "../slice/societyUsersGraphSlice";
import visitorPinSlice from "../slice/visitorPinSlice";
import updateVisitorPinSlice from "../slice/updateVisitorPinSlice";
import addImagesSlice from "../slice/addImagesSlice";
import getSocityImagesSlice from "../slice/getSocityImagesSlice";
import userUnsubscribeSlice from "../slice/userUnsubscribeSlice";
import societyVisitorListSlice from "../slice/societyVisitorListSlice";
import userRoleSwitchSlice from "../slice/userRoleSwitchSlice";
import userDeleteSlice from "../slice/userDeleteSlice";
import dashboardPresidentCountSlice from "../slice/dashboardPresidentCountSlice";
import resetUserPinSlice from "../slice/resetUserPinSlice"
import presidentActivitySlice from "../slice/presidentActivitySlice";
import unregisteredFlatsSlice from "../slice/unregisteredFlatsSlice";
import exportUnregisteredFlatListSlice from "../slice/exportUnregisteredFlatListSlice"
import userRoleDeleteSlice from "../slice/userRoleDeleteSlice"
import uploadCSVSlice from "../slice/uploadCSVSlice";
import fetchWhitelistUsers from "../slice/fetchWhitelistUsersSlice"
import ticketStausSlice  from "../slice/ticketStausSlice";

const store = configureStore({
  reducer: {
    userLoginData: userLoginSlice,
    presidentRegistretionData: presidentRegistretionSlice,
    allSocietyData: allSocietySlice,
    sociteyWingListData: sociteyWingListSlice,
    addSocietyData: addSocietySlice,
    societyWingListData: societyWingListSlice,
    societyFlatListData: societyFlatListSlice,
    addPresidentData: addPresidentSlice,
    societyListData: societyListSlice,
    societyDetailsData: societyDetailsSlice,
    societyUpdateData: societyUpdateSlice,
    societyStatusData: societyStatusSlice,
    userAuthenticationData: userAuthenticationSlice,
    dashboardSocietyCountData: dashboardSocietyCountSlice,
    societyComplaintData: societyComplaintSlice,
    helpDeskComplaintData: helpDeskComplaintSlice,
    dashboardActivitiesData: dashboardActivitiesSlice,
    userResetPinData: userResetPinSlice,
    presidentDetailsData: presidentDetailsSlice,
    presidentUpdateData: presidentUpdateSlice,
    manageUsersData: manageUsersSlice,
    amenityListData: amenityListSlice,
    addAmenitiesData: addAmenitiesSlice,
    ticketStausData: ticketStausSlice,
    societyAmenitiesData: societyAmenitiesSlice,
    societyStatusGraphData: societyStatusGraphSlice,
    societyUsersGraphData: societyUsersGraphSlice,
    visitorPinSliceData: visitorPinSlice,
    updateVisitorPinData: updateVisitorPinSlice,
    addImagesData: addImagesSlice,
    getSocityImagesData: getSocityImagesSlice,
    userUnsubscribeData: userUnsubscribeSlice,
    societyVisitorListData: societyVisitorListSlice,
    userRoleSwitchData: userRoleSwitchSlice,
    userDeleteData: userDeleteSlice,
    dashboardPresidentCountData: dashboardPresidentCountSlice,
    resetUserPin: resetUserPinSlice,
    presidentActivity: presidentActivitySlice,
    unregisteredFlats: unregisteredFlatsSlice,
    exportUnregisteredFlatList:exportUnregisteredFlatListSlice,
    userRoleDeleteData:userRoleDeleteSlice,
    uploadCsvData: uploadCSVSlice,
    userListData: fetchWhitelistUsers,
  },

  middleware: (getDefaultMiddleware) => {
    return [thunk];
  },
});

export default store;
